import React from 'react';
import { useLocation } from 'react-router-dom';
import ChannelInfo from '../components/ChannelInfo';
import ChannelVideos from '../components/ChannelVideos';

export default function VideoDetail() {
  const {state : {video} } = useLocation();
  const {title, channelId, channelTitle, description} = video.snippet;
  return (
    <section className='flex flex-col lg:flex-row'>
      <article className='basis-4/6'>
        <iframe title={title} id='player' type='text/html' width='100%' height='640' src={`https://www.youtube.com/embed/${video.id}`} />
        <div className='p-8'>
          <h2 className='text-xl font-bold'>{title}</h2>
          <ChannelInfo id={channelId} name={channelTitle}/>
          <pre className='whitespace-pre-wrap'>{description}</pre>
        </div>
      </article>
      <section className='basis-2/6'>
        <ChannelVideos id={channelId}/>
      </section>
    </section>
  );
}

